import { render, staticRenderFns } from "./MilitaryStatusTypeCards.vue?vue&type=template&id=7fafd1e2&"
import script from "./MilitaryStatusTypeCards.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports